import React from 'react';

const ShopTitle = ({ record }) => {
	return <span>Shop {record ? `"${record.name}"` : ''}</span>;
};
export default ShopTitle;
